/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type NotificationDto = {
    id?: number;
    userId?: number;
    type?: NotificationDto.type;
    priority?: NotificationDto.priority;
    title?: string;
    message?: string;
    relatedEntityId?: number;
    relatedEntityType?: string;
    isRead?: boolean;
    createdAt?: string;
};
export namespace NotificationDto {
    export enum type {
        NEW_PENDING_PRESEASON_GAME = 'NEW_PENDING_PRESEASON_GAME',
        PRESEASON_GAME_ACCEPTED = 'PRESEASON_GAME_ACCEPTED',
        PRESEASON_GAME_DATE_CHANGE_REQUEST = 'PRESEASON_GAME_DATE_CHANGE_REQUEST',
        PRESEASON_GAME_DATE_CHANGE_REQUEST_ACCEPTED = 'PRESEASON_GAME_DATE_CHANGE_REQUEST_ACCEPTED',
        PRESEASON_GAME_DATE_TIME_PROPOSAL_ACCEPTED = 'PRESEASON_GAME_DATE_TIME_PROPOSAL_ACCEPTED',
        PRESEASON_GAME_REJECTED = 'PRESEASON_GAME_REJECTED',
        PRESEASON_GAME_DELETED = 'PRESEASON_GAME_DELETED',
        NEW_MESSAGE = 'NEW_MESSAGE',
        NEW_USER = 'NEW_USER',
        LAST_MINUTE_PRESEASON_GAME_SEARCH = 'LAST_MINUTE_PRESEASON_GAME_SEARCH',
    }
    export enum priority {
        LOW = 'LOW',
        MEDIUM = 'MEDIUM',
        HIGH = 'HIGH',
    }
}

